import React, { createContext, type ReactNode, useContext } from 'react';

import invariant from 'tiny-invariant';

import { type GlobalSideNavigationProps } from '../../common/types';

export interface OptionsContextShape
	extends Pick<
		GlobalSideNavigationProps,
		| 'app'
		| 'appLabel'
		| 'orgId'
		| 'cloudId'
		| 'userId'
		| 'isShortcutsStatic'
		| 'networkStorageParams'
		| 'customizationStore'
		| 'disableMenuCustomization'
	> {
	// Whether level 1 drag & drop is enabled
	l1DragAndDropEnabled: boolean;
}

export const OptionsContext = createContext<OptionsContextShape | null>(null);

type OptionsProviderProps = {
	children: ReactNode;
	value: OptionsContextShape;
};

export function OptionsProvider({ children, value }: OptionsProviderProps) {
	return <OptionsContext.Provider value={value}>{children}</OptionsContext.Provider>;
}

export const useOptions = () => {
	const options = useContext(OptionsContext);

	invariant(options, 'useOptions must be used inside an initialized OptionsProvider');

	return options;
};
